import { getAppInfo } from './base'

export const initGa4 = () => {
   // 创建script 标签
   const script = document.createElement('script')
   script.src = 'https://www.googletagmanager.com/gtag/js?id=' + getAppInfo().ga4.id
   script.async = true
   document.head.appendChild(script)

    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());

    gtag('config', getAppInfo().ga4.id);
}